<app-settlements-table
  [settlements]="tables$ | async"
  [settlementsLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (tableCallback)="getTableCallback($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
></app-settlements-table>
